import { createTrackingUtils } from "../index.js";
export const flights_funnel_sr_page_size_increase_mobile = createTrackingUtils({
    name: "flights_funnel_sr_page_size_increase_mobile",
    defaultStage: 1,
    stages: {
        main: 1
    },
    goals: {},
    goalsWithValue: []
});
